<template>
  <div
    v-if="items.length > 0"
    class="wage-payroll-grid wage-payroll-grid--director-allowances wage-payroll-grid--director-premium-pay"
  >
    <template v-for="item in items" :key="item.type">
      <label
        class="wage-payroll-grid__label"
        :for="`director-premium-pay-${item.type}`"
      >{{ item.label }}</label>

      <div
        :id="`director-premium-pay-${item.type}`"
        class="wage-payroll-premium wage-director-premium-pay__row"
        :class="{ 'wage-director-premium-pay__row--off': !item.enabled }"
      >
        <div
          class="wage-director-premium-pay__choice"
          role="group"
          :aria-label="`${item.label} 지급 여부`"
        >
          <button
            type="button"
            class="wage-director-premium-pay__choice-btn"
            :class="{ 'wage-director-premium-pay__choice-btn--active': item.enabled }"
            :disabled="disabled"
            @click="emit('update:enabled', item.type, true)"
          >
            지급
          </button>
          <span class="wage-director-premium-pay__choice-sep" aria-hidden="true">|</span>
          <button
            type="button"
            class="wage-director-premium-pay__choice-btn"
            :class="{ 'wage-director-premium-pay__choice-btn--active': !item.enabled }"
            :disabled="disabled"
            @click="emit('update:enabled', item.type, false)"
          >
            미지급
          </button>
        </div>
        <span class="wage-payroll-premium__amount wage-payroll-grid__input wage-payroll-grid__input--readonly">
          {{ formatAmount(item.amount) }}
        </span>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
export type HomeWageDirectorPremiumPaySwitchType = 'overtime' | 'night' | 'holiday';

export interface HomeWageDirectorPremiumPaySwitchItem {
  type: HomeWageDirectorPremiumPaySwitchType;
  label: string;
  enabled: boolean;
  hours: number;
  amount: number;
}

defineProps<{
  items: HomeWageDirectorPremiumPaySwitchItem[];
  disabled?: boolean;
  formatAmount: (amount: number) => string;
}>();

const emit = defineEmits<{
  'update:enabled': [type: HomeWageDirectorPremiumPaySwitchType, enabled: boolean];
}>();
</script>
